import { render, staticRenderFns } from "./VFatherProAnamCAxACO.vue?vue&type=template&id=c0c69d2e"
import script from "./VFatherProAnamCAxACO.vue?vue&type=script&lang=js"
export * from "./VFatherProAnamCAxACO.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports